import axios from "axios";
import CripNotice from "crip-vue-notice";
import router from "./router";

const CancelToken = axios.CancelToken;
let cancelTokens = [];

// PRODUCTION SERVER
// export const productionAddr = "https://prod-api.stockants.com/api";
// export const serverHostName = "https://prod-api.stockants.com";

// CHAT PRODUCTION SERVER
// export const chatProductionAddr = "https://prod-chatapi.stockants.com/api";
// export const chatServerHostName = "https://prod-chatapi.stockants.com";

// // // UAT SERVER
export const productionAddr = "https://uat-api.stockants.com/api";
export const serverHostName = "https://uat-api.stockants.com";

// // // Chat UAT SERVER
export const chatProductionAddr = "https://uat-chatapi.stockants.com/api";
export const chatServerHostName = "https://uat-chatapi.stockants.com";


// function to add a new cancel token
function addCancelToken() {
  const source = CancelToken.source();
  cancelTokens.push(source);
  return source.token;
}

// Function to cancel all ongoing requests
function cancelAllRequests() {
  cancelTokens.forEach((source) => { console.log("soure", source); source.cancel("Request canceled due to error in one of the requests") });
  cancelTokens = []; // Reset after canceling
}

export const serverAddr = axios.create({
  baseURL: productionAddr,
  timeout: 300000,
  headers: {},
  withCredentials: true,
  cancelToken: addCancelToken(),      //add cancel token to each request
  transformRequest: [
    function (data, headers) {
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        headers["Authorization"] = "Bearer " + access_token;
      }
      headers["Content-Type"] = "application/json;charset=UTF-8";
      return JSON.stringify(data);
    },
  ],

  transformResponse: [
    function (data) {
      data = JSON.parse(data);
      if (!data.status && data.redirect) {      //if anything fails and got redirect in the api
        console.log("request failed");

        cancelAllRequests(); // cancel all requests if there’s an error

        handleRequestError(data);   //handle error and redirects

        return;
      }

      setToken(data);     //set all tokens

      if (!data.status && data.validation) {      //just to show validation - without validation
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }

      return data;
    },
  ],
});


// axios interceptor - gets call on each request and checks if current token is expired. if expired then get new token and store it somewhere
serverAddr.interceptors.request.use(async (req) => {
  let expires_in = window.localStorage.getItem("expire_in");
  const is_expired = new Date() > new Date(expires_in);

  if (!is_expired || !expires_in) return req;

  if (window.localStorage.getItem("refresh_token") || expires_in) {
    console.log("token time expired");


    cancelAllRequests(); // cancel all requests if there’s an error


    localStorage.clear();
    location.reload(true);
    router.push({ path: data.redirect || '/login' });

    // return axios
    //   .post(${productionAddr}/auth/v1/obtain_access_token, {
    //     refresh_token: window.localStorage.getItem("refresh_token"),
    //   })
    //   .then(function (response) {
    //     if (response.status == 200 && "token_data" in response.data) {

    //       setToken(response.data);    //set all tokens

    //       req.headers["Authorization"] = "Bearer " + response.data["token_data"]["access_token"];

    //       return req;
    //     } else {
    //       handleRequestError({});   //handle error and redirects
    //     }
    //   })
    //   .catch(function (err) {
    //     console.log("err", err);
    //     handleRequestError({});   //handle error and redirects
    //   });
  }
});

export const serverAddrForChat = axios.create({
  baseURL: chatProductionAddr,
  timeout: 300000,
  headers: {},
  withCredentials: true,
  cancelToken: addCancelToken(),      //add cancel token to each request
  transformRequest: [
    function (data, headers) {
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        headers["Authorization"] = "Bearer " + access_token;
      }
      headers["Content-Type"] = "application/json;charset=UTF-8";
      return JSON.stringify(data);
    },
  ],

  transformResponse: [
    function (data) {
      data = JSON.parse(data);
      if (!data.status && data.redirect) {      //if anything fails and got redirect in the api
        console.log("request failed");

        cancelAllRequests(); // cancel all requests if there’s an error

        handleRequestError(data);   //handle error and redirects

        return;
      }

      setToken(data);     //set all tokens

      if (!data.status && data.validation) {      //just to show validation - without validation
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }

      return data;
    },
  ],
});


// axios interceptor - gets call on each request and checks if current token is expired. if expired then get new token and store it somewhere
serverAddrForChat.interceptors.request.use(async (req) => {
  let expires_in = window.localStorage.getItem("expire_in");
  const is_expired = new Date() > new Date(expires_in);

  if (!is_expired || !expires_in) return req;

  if (window.localStorage.getItem("refresh_token") || expires_in) {
    console.log("token time expired");


    cancelAllRequests(); // cancel all requests if there’s an error


    localStorage.clear();
    location.reload(true);
    router.push({ path: data.redirect || '/login' });

    // return axios
    //   .post(${productionAddr}/auth/v1/obtain_access_token, {
    //     refresh_token: window.localStorage.getItem("refresh_token"),
    //   })
    //   .then(function (response) {
    //     if (response.status == 200 && "token_data" in response.data) {

    //       setToken(response.data);    //set all tokens

    //       req.headers["Authorization"] = "Bearer " + response.data["token_data"]["access_token"];

    //       return req;
    //     } else {
    //       handleRequestError({});   //handle error and redirects
    //     }
    //   })
    //   .catch(function (err) {
    //     console.log("err", err);
    //     handleRequestError({});   //handle error and redirects
    //   });
  }
});

function setToken(data) {
  if ("token_data" in data) {
    if ("access_token" in data.token_data) {
      window.localStorage.setItem("token", data["token_data"]["access_token"]);
    }

    if ("refresh_token" in data.token_data) {
      window.localStorage.setItem("refresh_token", data["token_data"]["refresh_token"]);
    }
  }

  if ("expire_in" in data) {
    window.localStorage.setItem("expire_in", data["expire_in"]);
  }
};

function handleRequestError(data) {
  let profile = null;
  let currentEnvironment = null;

  const notificationPromise = new Promise((resolve) => {
    new CripNotice({
      title: "Oops! Something went wrong!",
      description: data.validation || "Please login again",
      type: "error",
      duration: 3, // Duration in seconds
    });

    // Resolve the promise after the notification duration
    setTimeout(resolve, 0);
  });

  notificationPromise.then(() => {
    if (localStorage.getItem("profile")) {
      profile = JSON.parse(localStorage.getItem("profile"));

      if (localStorage.getItem("currentEnvironment")) {

        currentEnvironment = JSON.parse(localStorage.getItem("currentEnvironment"));

        if (localStorage.getItem("paytmSource") == "app" && profile.utm_source == "Paytm Money") {
          localStorage.clear();
          location.reload(true);
          window.history.back();

        } else if (currentEnvironment.byPassLogin) {
          localStorage.clear();
          location.reload(true);
          router.push({ path: "/auth-bypass" });

        } else {
          localStorage.clear();
          location.reload(true);
          router.push({ path: data.redirect || '/login' });
        }

      } else {
        localStorage.clear();
        location.reload(true);
        router.push({ path: data.redirect || '/login' });
      }
    } else {
      localStorage.clear();
      location.reload(true);
      router.push({ path: data.redirect || '/login' });
    }
  })
}

export const serverAddrToUploadMediaFiles = axios.create({
  baseURL: productionAddr,
  timeout: 30000,
  headers: {},
  withCredentials: true,
  transformRequest: [
    function (data, headers) {
      // Do whatever you want to transform the data
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        // data.token = access_token;
        headers["Authorization"] = "Bearer " + access_token;
      }

      headers["Content-Type"] = "multipart/form-data;";
      // return JSON.stringify(data);
      return data;
    },
  ],

  transformResponse: [
    function (data) {
      data = JSON.parse(data);
      if ("token" in data) {
        // delete serverAddr.defaults.headers['access-token'];
        window.localStorage.setItem("token", data["token"]);
      }
      if (!data.status && data.validation) {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }
      return data;
    },
  ],
});

export const serverAddrForChatToUploadMediaFiles = axios.create({
  baseURL: chatProductionAddr,
  timeout: 30000,
  headers: {},
  withCredentials: true,
  transformRequest: [
    function (data, headers) {
      // Do whatever you want to transform the data
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        // data.token = access_token;
        headers["Authorization"] = "Bearer " + access_token;
      }

      headers["Content-Type"] = "multipart/form-data;";
      // return JSON.stringify(data);
      return data;
    },
  ],

  transformResponse: [
    function (data) {
      data = JSON.parse(data);
      if ("token" in data) {
        // delete serverAddr.defaults.headers['access-token'];
        window.localStorage.setItem("token", data["token"]);
      }
      if (!data.status && data.validation) {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }
      return data;
    },
  ],
});

export const serverAddrForCSV = axios.create({
  baseURL: productionAddr,
  timeout: 30000,
  headers: {},
  withCredentials: true,
  transformRequest: [
    function (data, headers) {
      // Do whatever you want to transform the data
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        // data.token = access_token;
        headers["Authorization"] = "Bearer " + access_token;
      }

      headers["Content-Type"] = "application/json;charset=UTF-8";

      return JSON.stringify(data);
      // return data;
    },
  ],
  transformResponse: [
    function (data) {
      data = data;
      if (!data.status && data.validation) {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }
      return data;
    },
  ],
});